module.exports = __webpack_public_path__ + "img/jobs.67b57cb3.jpg";